import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoalCollectionSaveRequestDto } from '../../../store/landscapeAPI/goal/dto/request/goal-collection-save-request.dto';
import { GoalThemeSaveRequestDto } from '../../../store/landscapeAPI/goal/dto/request/goal-theme-save-request.dto';
import { GoalResponseDto } from '../../../store/landscapeAPI/goal/dto/response/goal-response.dto';
import { IndicatorGoalSaveRequestDto } from '../../../store/landscapeAPI/indicator/dto/request/indicator-goal-save-request.dto';
import { Button, Label } from '../../atoms';
import {
  ReportingDetailsGoalsForm,
  TranslationOrganism,
} from '../../organisms';
import BaseTemplate from '../BaseTemplate';
import cn from 'classnames';
import styles from './ReportingDetailsGoalsAddTemplate.module.css';
import { LocalesLanguagesConstants } from '../../../locales/locales';
import { PromiseSettledResult } from '../../../utils/types/types';

export interface ReportingDetailsGoalsAddTemplateProps {
  data: GoalResponseDto;
  goalThemes: GoalThemeSaveRequestDto[];
  handleOnGoalThemesChange: (goalThemes: GoalThemeSaveRequestDto[]) => void;
  goalCollections: GoalCollectionSaveRequestDto[];
  handleOnGoalCollectionsChange: (
    goalCollections: GoalCollectionSaveRequestDto[]
  ) => void;
  goalIndicators: IndicatorGoalSaveRequestDto[];
  handleOnGoalIndicatorsChange: (
    goalIndicators: IndicatorGoalSaveRequestDto[]
  ) => void;
  handleAddGoal: (goal: GoalResponseDto) => void;
  handleOnChange: (goal: GoalResponseDto) => void;
  setLanguage: React.Dispatch<React.SetStateAction<LocalesLanguagesConstants>>;
  selectedLanguage: LocalesLanguagesConstants;
  fromLanguage: LocalesLanguagesConstants;
  setFromLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  toLanguage: LocalesLanguagesConstants;
  setToLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  generateTranslation: () => Promise<void>;
  generateAllTranslations: () => Promise<PromiseSettledResult<void>[]>;
}

const ReportingDetailsGoalsAddTemplate: FC<
  ReportingDetailsGoalsAddTemplateProps
> = ({
  data,
  goalThemes,
  handleOnGoalThemesChange,
  goalCollections,
  handleOnGoalCollectionsChange,
  goalIndicators,
  handleOnGoalIndicatorsChange,
  handleAddGoal,
  handleOnChange,
  setLanguage,
  selectedLanguage,
  fromLanguage,
  setFromLanguage,
  toLanguage,
  setToLanguage,
  generateTranslation,
  generateAllTranslations,
}) => {
  const navigate = useNavigate();
  return (
    <BaseTemplate>
      <div className={styles.heading}>
        <Label content="Create Goal" size="lg" />
        <Button
          variant="link"
          onClick={() => navigate('/reporting-details/goals')}
          className={cn(styles.buttonLink)}
        >
          Go back to goal overview
        </Button>
      </div>
      <TranslationOrganism
        setLanguage={setLanguage}
        selectedLanguage={selectedLanguage}
        fromLanguage={fromLanguage}
        setFromLanguage={setFromLanguage}
        toLanguage={toLanguage}
        setToLanguage={setToLanguage}
        generateTranslation={generateTranslation}
        generateAllTranslations={generateAllTranslations}
      />
      <ReportingDetailsGoalsForm
        data={data}
        goalThemes={goalThemes}
        handleOnGoalThemesChange={handleOnGoalThemesChange}
        goalCollections={goalCollections}
        handleOnGoalCollectionsChange={handleOnGoalCollectionsChange}
        goalIndicators={goalIndicators}
        handleOnGoalIndicatorsChange={handleOnGoalIndicatorsChange}
        callbackFn={handleAddGoal}
        handleOnChange={handleOnChange}
      />
    </BaseTemplate>
  );
};

export default ReportingDetailsGoalsAddTemplate;
